<template>
    <div class="card card-animated product-card">
        <div class="card-body">
            <h5 class="product-title"><a :href="'/' + pageSlug + '/' + product.slug">{{ product.meta.title }}</a></h5>
            <h6 class="product-model">{{ product.type }}</h6>
            <a :href="'/' + pageSlug + '/' + product.slug" class="product-image" :class="{ unavailable: product.media === null }"
                :style="'background-image: url(' + (product.media.length ? product.media[0].fullUrl : './assets/images/icons/no-image.png') + ')'">
            </a>
            <div class="product-desc">
                <p>{{ product.meta.description }}</p>
            </div>
            <div class="product-price simple">
                <div :class="{ disabled: !product.discounted_price }" class="old-price">
                    <span class="value">{{ product.price | filterPrice }}</span>
                </div>
                <div class="new-price">
                    <a :href="'/' + pageSlug + '/' + product.slug" class="btn btn-primary">
                        Buy <span class="value">{{ (product.discounted_price ? product.discounted_price : product.price) | filterPrice }}</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ProductSaleCard",
    props: {
        product: {
            required: true
        },
        pageSlug: {
            type: String,
            default: 'specifications'
        }
    }
}
</script>

<style scoped>

</style>
